import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.css";
import { Button } from "..";

const Alert = ({
  className,
  buttonWrapperClassName,
  children,
  leftIcon,
  buttonMessage,
  onButtonClick,
  testId
}) => {
  const Icon = leftIcon;

  return (
    <div className={`${style.alert} ${className}`} data-testid={testId}>
      {leftIcon && <Icon className={style.icon} size="20px" noPointer />}
      <div className={style.message}>{children}</div>
      {buttonMessage && (
        <div className={`${style.button} ${buttonWrapperClassName}`}>
          <Button onClick={onButtonClick} theme="grayBackgroundXDarkGrayFont">
            {buttonMessage}
          </Button>
        </div>
      )}
    </div>
  );
};
Alert.propTypes = {
  className: PropTypes.string,
  buttonWrapperClassName: PropTypes.string,
  size: PropTypes.string,
  theme: PropTypes.string,
  name: PropTypes.string,
  noBorder: PropTypes.bool,
  src: PropTypes.string
};

export default Alert;
